/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconverterdone2Inputs */

const en_formatconverterdone2 = /** @type {(inputs: Formatconverterdone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formats created and saved to your media library.`)
};

const de_formatconverterdone2 = /** @type {(inputs: Formatconverterdone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formate erstellt und in deiner Mediathek gespeichert.`)
};

/**
* | output |
* | --- |
* | "Formats created and saved to your media library." |
*
* @param {Formatconverterdone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconverterdone2 = /** @type {((inputs?: Formatconverterdone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconverterdone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconverterdone2(inputs)
	return de_formatconverterdone2(inputs)
});
export { formatconverterdone2 as "formatConverterDone" }